import { healthControllerPing } from '@safc/api-client';
import { useEffect } from 'react';

/**
 * By calling any endpoint we trigger BE check if the token is near to be expired. If it is, the BE generates a new one and sets it in the cookies.
 */
export function useTokenRefresher() {
  useEffect(() => {
    const intervalId = setInterval(async () => { // we intentionally use setInterval rather than react-query refetch, because it works better if tab is in background
      try {
        await healthControllerPing();
      } catch (e) {
        console.warn('Backend healthcheck failure. Error', e);
      }
    }, 30_000);

    return () => clearInterval(intervalId);
  }, []);
}
